module.exports = __webpack_public_path__ + "static/media/조직문화 및 관리.46c7370d.png";